import { ContactAddressType } from './types'

export const getAddressValue = (contactName: string, contactAddress: ContactAddressType) => {
  return `${contactName} ${contactAddress.address} ${contactAddress.locality} ${contactAddress.state} ${contactAddress.zip}`
}
